import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import AuthContext from '../../auth/Context/AuthContext';
import axios from '../../adapters/API/axios';
import Swal from 'sweetalert2';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { ActionIcon, Box, Flex } from '@mantine/core';
import { BsPrinter } from 'react-icons/bs';
import ExportExcel from '../../component/ExportExcel';
import { GoInfo } from 'react-icons/go';
import { AgGridReact } from 'ag-grid-react';
import {
    AllCommunityModule,
    ModuleRegistry,
    colorSchemeLightCold,
    themeQuartz
} from 'ag-grid-community';
import ModalDetailLokasiAbsen from '../../component/Modal/ModalDetailLokasiAbsen';
import { useMediaQuery } from 'react-responsive';

function DetailAbsenKaryawan() {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { karyawanid } = useParams();
    const { tokens } = useContext(AuthContext);
    const tokenUser = tokens?.token;
    const [userDetail, setUserDetail] = useState();
    const [absensiMasuk, setAbsensiMasuk] = useState([]);
    const [absensiKeluar, setAbsensiKeluar] = useState([]);
    const navigate = useNavigate();
    const [lateDurations, setLateDurations] = useState(
        JSON.parse(localStorage.getItem('lateDurations')) || []
    );
    const [earlyOutDurations, setEarlyOutDurations] = useState(
        JSON.parse(localStorage.getItem('earlyOutDurations')) || []
    );
    const [overtimeDurations, setOvertimeDurations] = useState(
        JSON.parse(localStorage.getItem('overtimeDurations')) || []
    );

    const handleBack = () => {
        navigate(-1)
    }

    useEffect(() => {
        const fetchData = async () => {
            if (karyawanid !== undefined && tokenUser !== undefined) {

                await fetchUserDetail();
            }
        };

        fetchData();
    }, [karyawanid, tokenUser]);

    const calculateTotalDuration = (durations) => {
        return durations.reduce((acc, duration) => {
            const [hours, minutes, seconds] = duration.split(':');
            return acc + parseInt(hours) * 3600 + parseInt(minutes) * 60 + parseInt(seconds);
        }, 0);
    };

    const formatDuration = (totalSeconds) => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const formattedTotalLateDuration = formatDuration(calculateTotalDuration(lateDurations));
    const formattedTotalEarlyDuration = formatDuration(earlyOutDurations.length > 0 ? calculateTotalDuration(earlyOutDurations) : 0);
    const formattedTotalOverDuration = formatDuration(overtimeDurations.length > 0 ? calculateTotalDuration(overtimeDurations) : 0);


    useEffect(() => {
        const fetchData = async () => {
            if (karyawanid !== undefined && tokenUser !== undefined) {

                await fetchUserDetail();
                await fetchListAbsensiMasuk();
                await fetchListAbsensiKeluar();

            }
        };

        fetchData();
    }, [karyawanid, tokenUser]);


    const fetchUserDetail = () => {
        axios.get(`api/users/${karyawanid}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {

                setUserDetail(res.data);
                // fetchListGroup( res.data );
                // console.log( res.data )
            }).catch(err => {
                if (err.response?.status === 401) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Sesi Anda telah berakhir. Silahkan Login kembali.',
                        confirmButtonText: 'Login',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            navigate('/');
                        }
                    });

                } else (console.log(err))
            })
    };

    const fetchListAbsensiMasuk = () => {
        axios.get(`/api/checkin/?user_id=${karyawanid}`, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                withCredentials: true,
                Authorization: `Token ` + tokenUser,
            },
        })
            .then(res => {
                const currentDate = new Date();
                const currentMonth = currentDate.getMonth() + 1; // JavaScript months are zero-based
                const currentYear = currentDate.getFullYear();

                // Filter data for the current month
                const filteredData = res.data.filter(item => {
                    const checkinDate = new Date(item.checkin_time);
                    return checkinDate.getMonth() + 1 === currentMonth && checkinDate.getFullYear() === currentYear;
                });

                setAbsensiMasuk(res.data);
                const durationsLate = filteredData.map((item) => item.late_duration || "00:00:00");
                setLateDurations(durationsLate);

                // console.log( res.data )
            }).catch(err => {
                if (err.response?.status === 401) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Sesi Anda telah berakhir. Silahkan Login kembali.',
                        confirmButtonText: 'Login',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            navigate('/');
                        }
                    });

                } else (console.log(err))
            })
    };


    const fetchListAbsensiKeluar = () => {
        axios.get(`/api/checkout/?user_id=${karyawanid}`, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                withCredentials: true,
                Authorization: `Token ` + tokenUser,
            },
        })
            .then(res => {
                const currentDate = new Date();
                const currentMonth = currentDate.getMonth() + 1; // JavaScript months are zero-based
                const currentYear = currentDate.getFullYear();

                // Filter data for the current month
                const filteredData = res.data.filter(item => {
                    const checkoutDate = new Date(item.checkout_time);
                    return checkoutDate.getMonth() + 1 === currentMonth && checkoutDate.getFullYear() === currentYear;
                });

                setAbsensiKeluar(res.data);
                const durationsEarly = filteredData.map((item) => item.early_duration || "00:00:00");
                setEarlyOutDurations(durationsEarly);
                const durationsOver = filteredData.map((item) => item.overtime_duration || "00:00:00");
                setOvertimeDurations(durationsOver);
            }).catch(err => {
                // console.log( err )
            })
    };

    const [dataTable, setDataTable] = useState([]);

    useEffect(() => {
        const dataTableFilter = absensiMasuk.map(({ checkin_place, checkin_location, ...rest }) => rest);

        setDataTable(
            dataTableFilter.map((data) => {
                const tanggal = absensiKeluar.find((item) => item.checkout_time.split('T')[0] === data.checkin_time.split('T')[0]);
                const checkOutTime = tanggal ? tanggal.checkout_time : '';
                const earlyDuration = tanggal ? tanggal.early_duration : '';
                const overtimeDuration = tanggal ? tanggal.overtime_duration : '';

                return {
                    ...data,
                    checkout_time: checkOutTime,
                    early_duration: earlyDuration,
                    overtime_duration: overtimeDuration,
                };
            })
        );
    }, [absensiMasuk, absensiKeluar]);

    ModuleRegistry.registerModules([AllCommunityModule]);

    const themeLightCold = themeQuartz.withPart(colorSchemeLightCold);

    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        if (dataTable && dataTable.length > 0) {
            const dataTableFilter = dataTable.map(({ ...rest }) => rest);

            setRowData(
                dataTableFilter.map((data) => {
                    const datePartsCheckin = data?.checkin_time.split('T')[0].split('-');
                    const yearCheckin = Number(datePartsCheckin[0]);
                    const monthCheckin = Number(datePartsCheckin[1]) - 1;
                    const dayCheckin = Number(datePartsCheckin[2]);

                    const datePartsCheckout = data?.checkout_time.split('T')[0].split('-');
                    const yearCheckout = Number(datePartsCheckout[0]);
                    const monthCheckout = Number(datePartsCheckout[1]) - 1;
                    const dayCheckout = Number(datePartsCheckout[2]);

                    return {
                        ...data,
                        dateCheckin: new Date(yearCheckin, monthCheckin, dayCheckin),
                        dateCheckout: new Date(yearCheckout, monthCheckout, dayCheckout),
                    };
                })
            );
        }
    }, [dataTable]);

    const filterParams = {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
            if (!cellValue) return -1;

            const cellDate = new Date(cellValue.getFullYear(), cellValue.getMonth(), cellValue.getDate());

            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
            }
            return cellDate < filterLocalDateAtMidnight ? -1 : 1;
        },
        minValidYear: 2000,
        inRangeFloatingFilterDateFormat: "Do MMM YYYY",
    };

    const [showDetailLokasiAbsen, setShowDetailLokasiAbsen] = useState(false);
    const [rowSelected, setRowSelected] = useState()
    const handleShowModal = (row) => {
        setShowDetailLokasiAbsen(true);
        setRowSelected(row)
    };

    const colDefs = [
        {
            field: "detail",
            headerName: 'Detail',
            width: 120,
            pinned: 'left',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                        onClick={() => handleShowModal(row?.data)}
                    >
                        <GoInfo
                            size={20}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                );
            },
        },
        {
            field: "dateCheckin",
            headerName: "Tanggal Masuk",
            filter: "agDateColumnFilter",
            filterParams: filterParams,
            sort: 'desc',
            valueFormatter: (params) => {
                const dateCheckin = params.value;
                if (dateCheckin instanceof Date && !isNaN(dateCheckin)) {
                    const day = String(dateCheckin.getDate()).padStart(2, '0');
                    const month = String(dateCheckin.getMonth() + 1).padStart(2, '0');
                    const year = dateCheckin.getFullYear();
                    return `${day}-${month}-${year}`;
                }
                return '';
            }
        },
        {
            field: "dateCheckout",
            headerName: "Tanggal Pulang",
            filter: "agDateColumnFilter",
            filterParams: filterParams,
            sort: 'desc',
            valueFormatter: (params) => {
                const dateCheckout = params.value;
                if (dateCheckout instanceof Date && !isNaN(dateCheckout)) {
                    const day = String(dateCheckout.getDate()).padStart(2, '0');
                    const month = String(dateCheckout.getMonth() + 1).padStart(2, '0');
                    const year = dateCheckout.getFullYear();
                    return `${day}-${month}-${year}`;
                }
                return '';
            }
        },
        {
            field: "jam",
            headerName: 'Jam Masuk',
            cellRenderer: (row) => {
                const checkinTime = row?.data?.checkin_time;
                const formattedTime = checkinTime ? checkinTime?.split('T')[1]?.split('.')[0] : '';

                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {formattedTime}
                    </div>
                );
            },
        },
        {
            field: "jam",
            headerName: 'Jam Pulang',
            cellRenderer: (row) => {
                const checkoutTime = row?.data?.checkout_time;
                const formattedTimeOut = checkoutTime ? checkoutTime?.split('T')[1]?.split('.')[0] : '';

                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {formattedTimeOut}
                    </div>
                );
            },
        },
        {
            field: "late_duration",
            headerName: 'Telat',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.late_duration?.split('.')[0]}
                    </div>
                );
            },
        },
        {
            field: "early_duration",
            headerName: 'Pulang Awal',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.early_duration?.split('.')[0]}
                    </div>
                );
            },
        },
        {
            field: "overtime_duration",
            headerName: 'Lembur',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.overtime_duration?.split('.')[0]}
                    </div>
                );
            },
        },

    ];

    const defaultColDef = {
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true
    };

    const gridRef = useRef(null);

    const handleExportRowsExcelData = () => {
        if (!gridRef.current) return [];

        const filteredRows = [];
        gridRef.current.api.forEachNodeAfterFilterAndSort((node) => {
            if (node.data) {
                filteredRows.push(node.data);
            }
        });

        const excelData = filteredRows.map((row) => ({
            'Tanggal Masuk': row?.checkin_time ? row.checkin_time.split('T')[0] : '',
            'Tanggal Pulang': row?.checkout_time ? row.checkout_time.split('T')[0] : '',
            'Jam Masuk': row?.checkin_time ? row.checkin_time.split('T')[1].split('.')[0] : '',
            'Jam Pulang': row?.checkout_time ? row.checkout_time.split('T')[1].split('.')[0] : '',
            'Keterlambatan': row.late_duration ? row.late_duration?.split('.')[0] : '',
            'Pulang Awal': row.early_duration ? row.early_duration?.split('.')[0] : '',
            'Lembur': row.overtime_duration ? row.overtime_duration?.split('.')[0] : '',
        }));


        return excelData;
    };

    const handlePrint = () => {
        navigate('/report-absen-detail-karyawan', { state: { dataTable: dataTable, user_name: userDetail?.first_name + " " + userDetail?.last_name } });
    };

    return (
        <>
            <Container className='mt-4'>
                <Row>
                    <Col xs={6} md={11} className='my-auto'>
                        <h1 className='display-6 text-start' style={{ fontFamily: 'Poppins-Light' }} >Detail Absensi</h1>

                    </Col>
                    <Col xs={6} md={1} className='text-end'>
                        <Button
                            onClick={handleBack}
                            variant='btn'
                            style={{ minHeight: '50px', backgroundColor: '#696969', color: 'white', fontFamily: 'Poppins-Regular' }}
                        >
                            Kembali
                        </Button>
                    </Col>
                </Row>
            </Container>
            <h3 className='text-center mt-3' style={{ fontFamily: 'Poppins-Regular' }}>{userDetail?.first_name} {userDetail?.last_name}</h3>
            <Container fluid className='mt-5'>
                {/* <MantineReactTable
                    table={table}
                /> */}
                <Box>
                    {/* Top Toolbar */}
                    <Box
                        sx={{
                            display: 'flex',
                            gap: '16px',
                            padding: '8px',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Flex gap="xs" align="center">
                            <ActionIcon onClick={handlePrint}>
                                <BsPrinter style={{ backgroundColor: 'transparent', color: '#222' }} size={40} />
                            </ActionIcon>
                            <ActionIcon>
                                <ExportExcel
                                    getExcelData={handleExportRowsExcelData}
                                    fileName={`Report Absensi Detail ${userDetail?.first_name} ${userDetail?.last_name}`}
                                />
                            </ActionIcon>
                        </Flex>
                    </Box>
                    <div style={{ height: 500 }}>

                        <AgGridReact
                            theme={themeLightCold}
                            ref={gridRef}
                            rowData={rowData}
                            columnDefs={colDefs}
                            defaultColDef={defaultColDef}
                            pagination={isMobile ? false : true}
                            rowHeight={25}
                        />

                    </div>

                    <ModalDetailLokasiAbsen
                        rowSelected={rowSelected}
                        showDetailLokasiAbsen={showDetailLokasiAbsen}
                        setShowDetailLokasiAbsen={setShowDetailLokasiAbsen}
                    />
                </Box>
                <div className='my-3' style={{ fontFamily: 'Poppins-Regular' }}>
                    <h5>Total Keterlambatan Bulan Ini: {formattedTotalLateDuration}</h5>
                    <h5>Total Pulang Awal Bulan Ini: {formattedTotalEarlyDuration}</h5>
                    <h5>Total Lembur Bulan Ini: {formattedTotalOverDuration}</h5>
                </div>
            </Container>
        </>
    )
}

export default DetailAbsenKaryawan
